// Copyright (c) Docugami, Inc. All rights reserved.

export interface SettingsState {
    settingsPanelShowing: boolean;
}

export const SET_SETTINGS_PANEL_SHOWING = "SET_SETTINGS_PANEL_SHOWING";

interface SetSettingsPanelShowing {
    type: typeof SET_SETTINGS_PANEL_SHOWING;
    payload: boolean;
}

export type SettingsActionTypes = SetSettingsPanelShowing;
